const mutations = {
	
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js